import { useGlobalState, useSelectors } from '@exodus/headless-react';
import { WalletAccount } from '@exodus/models';
import { useSelector } from 'react-redux';
const useToWalletAccount = () => {
    const selectors = useSelectors();
    const getWalletAccount = useSelector(selectors.walletAccounts.get);
    const [toWalletAccountName, setToWalletAccount] = useGlobalState({
        namespace: 'exchange',
        key: 'toWalletAccount',
        defaultValue: WalletAccount.DEFAULT_NAME,
        persist: true,
    });
    const toWalletAccount = toWalletAccountName
        ? getWalletAccount(typeof toWalletAccountName === 'string'
            ? toWalletAccountName
            : toWalletAccountName.toString())
        : null;
    const handleToWalletAccountChange = (walletAccount) => {
        const name = walletAccount.toString();
        setToWalletAccount(name);
    };
    return [toWalletAccount, handleToWalletAccountChange];
};
export default useToWalletAccount;
